import React from 'react'
import { useIntl } from 'react-intl'
import { Empty as AntdEmpty, Typography, Button } from 'antd'
import { Add } from 'components/UI/Button'
import EmptyIllustration from './EmptyIllustration'
import styles from './empty.module.scss'

const { Title } = Typography

const Empty = ({
  title,
  description,
  appendDescription,
  onAdd,
  onResetFilter,
  isFiltered,
  name,
}) => {
  const { formatMessage } = useIntl()

  if (isFiltered) {
    return (
      <AntdEmpty
        description={
          <div>
            <Title level={4} className={styles.emptyTitle}>
              {title ?? formatMessage({ id: 'table.no_results_found' })}
            </Title>
            <Title
              className={[styles.emptyDescription, styles.hasAppendDescription].join(' ')}
              level={5}
            >
              {description ?? formatMessage({ id: 'table.no_results_hint' })}
            </Title>
            {typeof onResetFilter === 'function' && (
              <Button onClick={onResetFilter} className={styles.emptyResetButton}>
                {formatMessage({ id: 'table.reset_filter' })}
              </Button>
            )}
          </div>
        }
        image={<EmptyIllustration className={styles.emptyImage} />}
        className={styles.empty}
      />
    )
  }

  return (
    <AntdEmpty
      description={
        <div>
          <Title level={4} className={styles.emptyTitle}>
            {title}
          </Title>
          {onAdd === undefined && !!description && (
            <Title
              className={[
                styles.emptyDescription,
                appendDescription ? styles.hasAppendDescription : null,
              ].join(' ')}
              level={5}
            >
              {description}
            </Title>
          )}
          {appendDescription}
          {typeof onAdd === 'function' && (
            <>
              <Title
                className={[styles.emptyDescription, styles.hasAppendDescription].join(' ')}
                level={5}
              >
                {description ?? formatMessage({ id: 'table.lets_create_your_first_x' }, { name })}
              </Title>

              <Add
                onClick={onAdd}
                title={name && `${formatMessage({ id: 'button.add' })} ${name}`}
                className={styles.emptyAddButton}
              />
            </>
          )}
        </div>
      }
      image={<EmptyIllustration className={styles.emptyImage} />}
      className={styles.empty}
    />
  )
}

export default Empty
